import { jsx as _jsx } from 'react/jsx-runtime.js';
import { CardContent, Flex } from '@stepstone-genesis/components';
import { TwoStepLoginRegistration } from '../../../forms/TwoStepLoginRegistration/index.js';
export const RightSideContent = () => {
    return (_jsx(CardContent, { sx: { width: ['100%', '51.5%'] }, backgroundColor: 'colorWhite', pt: ['spaceM', 'spaceL'], children: _jsx(Flex, { flxJustify: 'center', flxContent: 'center', flxItems: ['start', 'center'], sx: { height: '100%' }, children: _jsx(TwoStepLoginRegistration, {}) }) }));
};
//# sourceMappingURL=RightSideContent.js.map